import { Box, Typography } from '@coolblue-development/freddy';
import SuccessIcon from '../../Icons/SuccessIcon';

interface EmptyStateProps {
  title: string;
}

const EmptyState = ({ title }: EmptyStateProps): JSX.Element => (
  <Box
    data-testid="empty-state"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      gap: '24px',
      padding: '24px',
      textAlign: 'center'
    }}
  >
    <SuccessIcon width={48} height={48} />

    <Box>
      <Typography variant="h2" sx={{ marginBottom: '8px' }}>
        {title}
      </Typography>
      <Typography variant="body" sx={{ color: '#767676' }}>
        You're all caught up
      </Typography>
    </Box>
  </Box>
);

export default EmptyState;
